/* eslint-disable @typescript-eslint/no-explicit-any */
export type TDealType = 'sale' | 'rent' | 'rentDay';

import { IDynamicInfoBlock } from '../dynamicInfo';

export interface IChartDataResponse {
  /** Крайняя правая дата на графике **/
  datesLabels: string[] | null;
  /** Упорядоченный список цен на каждый день в рублях **/
  secondLineValues: number[] | null;
  /** Наибольшая цена на вертикальной оси графика **/
  maxChartValue: number | null;
  /** Наименьшая цена на вертикальной оси графика **/
  minChartValue: number | null;
  /** Упорядоченный список оценок на каждый день в рублях **/
  firstLineValues: number[] | null;
  /** Шаг вертикальной шкалы цен**/
  labelStep: number;
}

export type TChartDataApiResponseError = null;

export type TChartDataApiResponseSuccess = IChartDataResponse;

export type TChartDataApiResponse = TChartDataApiResponseSuccess | TChartDataApiResponseError;

export type TChartData = Required<IChartDataResponse>;

export enum EChartType {
  Price,
  OffersCount,
  OffersViewed,
  Mortgage,
}

export interface IChartConfigOptions extends TChartData {
  onClick?(event: MouseEvent, elements: any[]): void;
  onHover?(event: MouseEvent, elements: any[]): void;
  firstLabel: string;
  secondLabel?: string;
  priceUnit: string;
  chartType: EChartType;
  chartHeight: number;
}

export interface IChartScale {
  ticks: Array<{ label: string | number; value: string | number }>;
  [key: string]: any;
}

export interface ITick {
  label?: string | number;
}

export interface IChartBlock {
  block?: IDynamicInfoBlock | null;
  chart?: IChartDataResponse | null;
}

export interface IChartState {
  prices: IChartBlock | null;
  demand: IChartBlock | null;
  supply: IChartBlock | null;
  mortgage: IChartBlock | null;
  loading: boolean;
}
